import React from 'react';
import indexOf from 'lodash/indexOf';
import hexRgb from '../../utils/hex2rgba';

class LegendItem extends React.Component {
  constructor(props){
    super(props);
    const { displayName, url, layerList, mapLayer, legendURL } = props.layer;
    let customContent;
    let src = url + `&service=WMS&version=1.1.1&request=GetLegendGraphic&format=image/png&sld_version=1.1.0&layer=${layerList}`;
    
    if(legendURL) {
      src = legendURL
    }else if(layerList[0]==='cog_layer' || layerList[0]==='cog_xyz') {
      const lyrSrc = mapLayer.getSource()
      const lyrOpacity = mapLayer.getOpacity();
      const lyrUrl = new URL(lyrSrc.getUrls()[0]);
      const classGroup = lyrUrl.searchParams.get('CLASSGROUP');
      src = src+`&CLASSGROUP=${classGroup}`;
      if(classGroup.includes('custom')) {
        customContent=[]
        for(let i=0; i< props.layer.info.rasterClass.length; i++) {
          const {name, color, low, high} = props.layer.info.rasterClass[i];
          const colorArr = color.split(' ')
          const colorString = colorArr.join(',');
          let label;
          if(high) {
            label=`${low} - ${high}`
          }else{
            label=`All Values >${low}`
          }
          customContent.push(
            <div key={`customLegend-${displayName}-${i}`} style={{width:'100%', display:'flex', marginBottom:'2px', alignItems:'center'}}>
              <svg width="24" height="12" xmlns="http://www.w3.org/2000/svg" version="1.1" style={{marginRight:'6px'}}>
                <rect x="0" y="0" width="24" height="12" fillOpacity={lyrOpacity} fill={`rgb(${colorString})`}/>
              </svg>
              {label}
            </div>
            ) 
          }
      }
      
    }else if(layerList[0]==='flood_extent') {
      customContent=[]
      const lyrSrc = mapLayer.getSource()
      const lyrOpacity = mapLayer.getOpacity();
      const params = lyrSrc.getParams();
      const fColor = params.fColor;
      const rgbStr = hexRgb(fColor);
      customContent.push(
        <div key={`customLegend-${displayName}`} style={{width:'100%', display:'flex', marginBottom:'2px', alignItems:'center'}}>
          <svg width="24" height="12" xmlns="http://www.w3.org/2000/svg" version="1.1" style={{marginRight:'6px'}}>
            <rect x="0" y="0" width="24" height="12" fillOpacity={lyrOpacity} fill={`rgb(${rgbStr.red},${rgbStr.green},${rgbStr.blue})`}/>
          </svg>
          Flood Extent
        </div>
        ) 

    }
    
    this.state = {
      displayName: displayName,
      src: src,
      content: customContent
    }
  }


  render(){
    const { src, displayName, content } = this.state;
    if(content){
      return (
        <li className="list-group-item">
          <div className="overflow-ellipsis" title={ displayName }><strong>{ displayName }</strong></div>
          {content}
        </li>
      )
    }else{
      return (
        <li className="list-group-item">
          <div className="overflow-ellipsis" title={ displayName }><strong>{ displayName }</strong></div>
          <img alt={`Example of style for ${ displayName }`} src={ src }></img>
        </li>
      )
    }
    
  }
}

export default LegendItem;